<link rel="ractive" href="../r-page.html">
<link rel="ractive" href="../components/header.html" name="c-header">
<link rel="ractive" href="../components/footer.html" name="c-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-notification></c-notification>
	<c-header></c-header>

	<div class="p-sponsors">
		<div class="navigation">
			<a class="active">Our sponsors</a>
			<a href="/become-a-sponsor">Become our sponsor</a>
		</div>

		<div class="container">
			<div class="head-wrapper">
				<div class="head-wrapper_map-wrapper">
					<img class="head-map-bg" width="908" height="428" src="{{@shared.assetsHost}}/img/sponsors/map.svg" />
				</div>

				<div class="head-title">
					Our Sponsors
				</div>

				<div class="head-subtitle">
					Support us
				</div>

				<div class="head-descr">
					<span>Support jsDelivr by donating to us through GitHub Sponsors and Open Collective and help cover the expenses of our infrastructure and sponsor the development of new features</span>
				</div>

				<div class="head-ctrls">
					<a target="_blank" rel="noopener noreferrer" href="https://github.com/sponsors/jsdelivr">
						<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/github.black.svg" />
						GitHub Sponsors
					</a>
					<a target="_blank" rel="noopener noreferrer" href="https://opencollective.com/jsdelivr">
						<img width="18" height="18" src="{{@shared.assetsHost}}/img/icons/open-collective.svg" />
						Open Collective
					</a>
				</div>
			</div>

			<h3 class="sp-header platinum-header" id="platinum">PLATINUM</h3>

			<div class="sp-row">
				<div class="sp-item">
					<div class="sp">
						<img class="sp-img" width="167" height="60" src="{{@shared.assetsHost}}/img/sponsors/cloudflare.png" srcset="{{@shared.assetsHost}}/img/sponsors/cloudflare@2x.png 2x">

						<div class="sp-text">
							Main backend CDN for jsDelivr offering unlimited bandwidth and locations.
							"Offers free and commercial, cloud-based services to help secure and accelerate
							websites."
						</div>

						<a class="sp-link" target="_blank" rel="noopener noreferrer" href="https://www.cloudflare.com">
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/share.svg">
							www.cloudflare.com
						</a>
					</div>
				</div>

				<div class="sp-item">
					<div class="sp">
						<img class="sp-img" width="126" height="60" src="{{@shared.assetsHost}}/img/sponsors/fastly.png" srcset="{{@shared.assetsHost}}/img/sponsors/fastly@2x.png 2x">

						<div class="sp-text">
							Main backend CDN for jsDelivr offering unlimited bandwidth and locations.
							"Fastly's edge cloud platform powers fast, secure, and scalable digital experiences."
						</div>

						<a target="_blank" rel="noopener noreferrer" href="https://www.fastly.com" class="sp-link">
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/share.svg">
							www.fastly.com
						</a>
					</div>
				</div>

				<div class="sp-item">
					<div class="sp">
						<img class="sp-img" width="150" height="60" src="{{@shared.assetsHost}}/img/sponsors/ibm.svg">

						<div class="sp-text">
							Our DNS hosting provider offering unlimited DNS queries and an additional
							layer of failover.
							"Industry leading DNS traffic management - managed DNS, private DNS networks, and
							powerful turnkey traffic routing setups."
						</div>

						<a target="_blank" rel="noopener noreferrer" href="https://www.ibm.com/products/ns1-connect" class="sp-link">
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/share.svg">
							www.ibm.com
						</a>
					</div>
				</div>

				<div class="sp-item">
					<div class="sp">
						<img class="sp-img"
							height="60"
							src="{{@shared.assetsHost}}/img/sponsors/g-core.svg"
							loading="lazy">
						<div class="sp-text">
							Regional and backup CDN for jsDelivr offering unlimited bandwidth and locations.
							"A secure Edge & Cloud Platform to go global faster. Offering low-latency services
							around the world, trusted by the largest online businesses."
						</div>

						<a target="_blank" rel="noopener noreferrer" href="https://gcore.com" class="sp-link">
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/share.svg">
							gcore.com
						</a>
					</div>
				</div>

				<div class="sp-item">
					<div class="sp">
						<img class="sp-img" width="207" height="60" src="{{@shared.assetsHost}}/img/sponsors/bunny.png" srcset="{{@shared.assetsHost}}/img/sponsors/bunny@2x.png 2x">

						<div class="sp-text">
							Regional and backup CDN for jsDelivr offering unlimited bandwidth and locations.
							"Go faster than the fastest with our next-generation CDN, edge storage, and optimization service."
						</div>

						<a target="_blank" rel="noopener noreferrer" href="https://bunny.net" class="sp-link">
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/share.svg">
							bunny.net
						</a>
					</div>
				</div>

				<div class="sp-item">
					<div class="sp">
						<img class="sp-img render" width="157" height="30" src="{{@shared.assetsHost}}/img/sponsors/render-black.svg">

						<div class="sp-text">
							Main hosting provider for jsDelivr related websites and APIs.
							"Render is a unified cloud to build and run all your apps and websites with free SSL,
							a global CDN, private networks and auto deploys from Git."
						</div>

						<a target="_blank" rel="noopener noreferrer" href="https://render.com" class="sp-link">
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/share.svg">
							render.com
						</a>
					</div>
				</div>
			</div>

			<h3 class="sp-header gold-header" id="gold">GOLD</h3>

			<div class="sp-row row-gold">
				<div class="sp-item">
					<div class="sp">
						<img class="sp-img" width="169" height="60" src="{{@shared.assetsHost}}/img/sponsors/algolia.png" srcset="{{@shared.assetsHost}}/img/sponsors/algolia@2x.png 2x" loading="lazy">

						<div class="sp-text">
							Algolia Search provides hosted full-text, numerical, faceted and geolocalized search.
						</div>

						<a target="_blank" rel="noopener noreferrer" href="https://www.algolia.com" class="sp-link">
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/share.svg">
							www.algolia.com
						</a>
					</div>
				</div>

				<div class="sp-item">
					<div class="sp">
						<img class="sp-img" width="150" height="60" src="{{@shared.assetsHost}}/img/sponsors/cloudns.png" srcset="{{@shared.assetsHost}}/img/sponsors/cloudns@2x.png 2x" loading="lazy">

						<div class="sp-text">
							ClouDNS is offering Premium, DDoS Protected, and GeoDNS services supported by Global Anycast network.
						</div>

						<a target="_blank" rel="noopener noreferrer" href="https://www.cloudns.net" class="sp-link">
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/share.svg">
							www.cloudns.net
						</a>
					</div>
				</div>

				<div class="sp-item">
					<div class="sp">
						<img class="sp-img" width="237" height="60" src="{{@shared.assetsHost}}/img/sponsors/digitalocean.png" srcset="{{@shared.assetsHost}}/img/sponsors/digitalocean@2x.png 2x" loading="lazy">

						<div class="sp-text">
							Helping millions of developers easily build, test, manage, and scale applications of any size.
						</div>

						<a target="_blank" rel="noopener noreferrer" href="https://www.digitalocean.com" class="sp-link">
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/share.svg">
							www.digitalocean.com
						</a>
					</div>
				</div>
			</div>

			<h3 class="sp-header bronze-header" id="bronze">BRONZE</h3>

			<div class="sp-row row-bronze">
				<div class="sp-item">
					<div class="sp" title="Clever Cloud">
						<a target="_blank" rel="noopener noreferrer" href="https://www.clever-cloud.com">
							<img class="sp-img" width="231" height="60" src="{{@shared.assetsHost}}/img/sponsors/clever-cloud.png" srcset="{{@shared.assetsHost}}/img/sponsors/clever-cloud@2x.png 2x" loading="lazy">
						</a>
					</div>
				</div>

				<div class="sp-item">
					<div class="sp" title="Prebid">
						<a target="_blank" rel="noopener noreferrer" href="https://prebid.org">
							{{! filename is "pb" because "prebid" keyword is commonly blocked by ad blockers }}
							<img class="sp-img" width="201" height="60" src="{{@shared.assetsHost}}/img/sponsors/pb.png" srcset="{{@shared.assetsHost}}/img/sponsors/pb@2x.png 2x" loading="lazy">
						</a>
					</div>
				</div>

				<div class="sp-item">
					<div class="sp" title="SpeedCurve">
						<a target="_blank" rel="noopener noreferrer" href="https://www.speedcurve.com">
							<img class="sp-img" width="265" height="60" src="{{@shared.assetsHost}}/img/sponsors/speedcurve.png" srcset="{{@shared.assetsHost}}/img/sponsors/speedcurve@2x.png 2x" loading="lazy">
						</a>
					</div>
				</div>

				<div class="sp-item">
					<div class="sp" title="PackageCloud">
						<a target="_blank" rel="noopener noreferrer" href="https://packagecloud.io">
							<img class="sp-img packagecloud" width="223" height="30" src="{{@shared.assetsHost}}/img/sponsors/packagecloud.png" srcset="{{@shared.assetsHost}}/img/sponsors/packagecloud@2x.png 2x" loading="lazy">
						</a>
					</div>
				</div>

				<div class="sp-item">
					<div class="sp" title="BairesDev">
						<a target="_blank" rel="noopener noreferrer" href="https://www.bairesdev.com/sponsoring-open-source-projects/">
							<img class="sp-img" width="223" height="60" src="{{@shared.assetsHost}}/img/sponsors/bairesdev.svg" loading="lazy">
						</a>
					</div>
				</div>

				<div class="sp-item">
					<div class="sp" title="Route4Me">
						<a target="_blank" rel="noopener noreferrer" href="https://route4me.com/">
							<img class="sp-img" width="250" height="60" src="{{@shared.assetsHost}}/img/sponsors/route_4_me.svg" alt="Route Planner and Route Optimizer" loading="lazy">
						</a>
					</div>
				</div>

				<div class="sp-item">
					<div class="sp"
						title="Dotcom-Monitor is a trusted leader in website and network monitoring, providing a comprehensive suite of tools to keep digital assets secure, optimized, and available 24/7. With over two decades of experience, Dotcom-Monitor serves thousands of organizations globally.">
						<a target="_blank" rel="noopener noreferrer" href="https://www.dotcom-monitor.com/sponsoring-open-source-projects/">
							<img class="sp-img dotcom-monitor"
								width="245"
								height="25"
								src="{{@shared.assetsHost}}/img/sponsors/dotcom-monitor.svg"
								alt="Advanced Website Monitoring Solutions"
								loading="lazy">
						</a>
					</div>
				</div>
			</div>

			<div class="be-a-sp">
				<img width="41" height="40" src="{{@shared.assetsHost}}/img/icons/heart.svg">
				<span class="be-a-sp-text">Help us make jsDelivr even better</span>
				<a class="btn-primary be-a-sp-btn" target="_blank" href="/become-a-sponsor">Become our sponsor</a>
			</div>
		</div>
	</div>

	<c-footer></c-footer>
</r-page>


<script>
	component.exports = {
		data () {
			return {
				title: 'Our Sponsors - jsDelivr',
				description: 'jsDelivr is sponsored by Cloudflare, Fastly, Bunny, IBM, and other awesome companies.',
			};
		},
	};
</script>
